import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {unpackId} from 'common/diplomatIdUtil';
import {usePartnersRefs} from 'redux/partners/hooks/usePartnersRefs';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';
import {useDispatch} from 'react-redux';
import actions from 'features/layout/redux/actions';
import {useDeleteApi} from 'common/hooks/useDeleteApi';
import api from 'api';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {useTranslation} from 'react-i18next';
import React from 'react';
import {useModal} from 'common/hooks/useModal';
import DeleteKeyDialog from 'features/layout/DialogRoutes/dialogs/keys/DeleteKeyDialog';
import {usePostApi} from 'common/hooks/usePostApi';

type DeletePGPKeyDialogProps = {
   data: INav;
   onClose: () => void;
};

const DeletePGPKeyDialog = ({data, onClose}: DeletePGPKeyDialogProps) => {
   const {t} = useTranslation();
   const {open, handleOpen, handleClose} = useModal();
   const dispatch = useDispatch();
   const {id} = unpackId(data.id);
   const partners = usePartnersRefs(id, 'pgp');
   const transactions = useTransactionsRefs(id, 'pgp');
   const isPublicKey = data.objectType === DiplomatObjectType.enum.PUBLIC_KEY;
   const onSuccess = () => {
      dispatch(actions.loadTreeNav());
      onClose();
   };
   //TODO: Figure out how to understand that entered passphrase was invalid
   const onFailure = (error: string, message: string) => {
      if (message.includes('Passphrase is invalid')) {
         handleOpen();
      }
   };
   const {request} = useDeleteApi(`${api.pgpKeys}/${isPublicKey ? 'public' : 'keypair'}/${id}`, {
      onSuccess,
   });
   const {request: clearKeyRequest} = usePostApi(`${api.pgpKeyClear}`, {
      onSuccess,
   });

   const handleConfirm = (values?: {passphrase: string; force: boolean}) => {
      if (values?.force) {
         handleClose();
      }
      request({searchParams: values, onFailure});
   };

   const handleClear = () => {
      clearKeyRequest(
         JSON.stringify({
            existingKeyId: id,
         })
      );
   };

   const dialogTitle = isPublicKey
      ? t('Delete OpenPGP Public Key Confirmation')
      : t('Delete OpenPGP Key Pair Confirmation');

   return (
      <DeleteKeyDialog
         dialogTitle={dialogTitle}
         data={data}
         partners={partners}
         transactions={transactions}
         requirePassphrase={!isPublicKey}
         forceDeletionPrompt={open}
         onConfirm={handleConfirm}
         onClose={onClose}
         onClear={handleClear}
      />
   );
};

export default DeletePGPKeyDialog;
